export const BEFORE = 'before';
export const AFTER = 'after';
export const BEFORE_WITH_SPACE = 'before_with_space';
export const AFTER_WITH_SPACE = 'after_with_space';
export const BEFORE_VALUE = 'before_value';
export const AFTER_VALUE = 'after_value';

export const DOT_SEAPRATOR = '.';
export const COMMA_SEAPRATOR = ',';

export const TIER_PRICES = 'TIER_PRICES';
export const PRICE_CONFIGS = {
    CZK: {
        show_symbol: AFTER_WITH_SPACE,
        group_separator: DOT_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: 'Kč',
        decimal_separator: COMMA_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    DKK: {
        show_symbol: AFTER_WITH_SPACE,
        group_separator: DOT_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: 'kr',
        decimal_separator: COMMA_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    EUR: {
        show_symbol: AFTER_WITH_SPACE,
        group_separator: DOT_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: '€',
        decimal_separator: COMMA_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    HUF: {
        show_symbol: AFTER_WITH_SPACE,
        group_separator: DOT_SEAPRATOR,
        decimal_number: '0',
        minus_sign: '-',
        symbol: 'Ft',
        decimal_separator: COMMA_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    NOK: {
        show_symbol: BEFORE_WITH_SPACE,
        group_separator: ' ',
        decimal_number: '2',
        minus_sign: '-',
        symbol: 'kr',
        decimal_separator: COMMA_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    PLN: {
        show_symbol: AFTER_WITH_SPACE,
        group_separator: DOT_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: 'zł',
        decimal_separator: COMMA_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    RON: {
        show_symbol: AFTER_WITH_SPACE,
        group_separator: DOT_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: 'Lei',
        decimal_separator: COMMA_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    SEK: {
        show_symbol: AFTER_WITH_SPACE,
        group_separator: DOT_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: 'kr',
        decimal_separator: COMMA_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    CHF: {
        show_symbol: BEFORE_WITH_SPACE,
        group_separator: COMMA_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: 'CHF',
        decimal_separator: DOT_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    AUD: {
        show_symbol: BEFORE_WITH_SPACE,
        group_separator: COMMA_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: '$',
        decimal_separator: DOT_SEAPRATOR,
        show_minus: BEFORE_VALUE
    },
    CAD: {
        show_symbol: BEFORE_WITH_SPACE,
        group_separator: COMMA_SEAPRATOR,
        decimal_number: '2',
        minus_sign: '-',
        symbol: '$',
        decimal_separator: DOT_SEAPRATOR,
        show_minus: BEFORE_VALUE
    }
};
export default {
    AED: 'د.إ',
    AFN: '؋',
    ALL: 'L',
    AMD: '֏',
    ANG: 'ƒ',
    AOA: 'Kz',
    ARS: '$',
    AUD: '$',
    AWG: 'ƒ',
    AZN: '₼',
    BAM: 'KM',
    BBD: 'Bds$',
    BDT: '৳',
    BGN: 'лв',
    BHD: '.د.ب',
    BIF: 'FBu',
    BMD: '$',
    BND: 'B$',
    BOB: '$b',
    BRL: 'R$',
    BSD: 'B$',
    BTC: '฿',
    BTN: 'Nu.',
    BWP: 'P',
    BYR: 'Br',
    BYN: 'Br',
    BZD: 'BZ$',
    CAD: 'CA$',
    CDF: 'FC',
    CHF: 'CHF',
    CLP: '$',
    CNY: '¥',
    COP: '$',
    CRC: '₡',
    CUC: 'CUC$',
    CUP: '₱',
    CVE: '$',
    CZK: 'Kč',
    DJF: 'Fdj',
    DKK: 'kr',
    DOP: 'RD$',
    DZD: 'دج',
    EEK: 'kr',
    EGP: '£',
    ERN: 'Nfk',
    ETB: 'Br',
    ETH: 'Ξ',
    EUR: '€',
    FJD: 'FJ$',
    FKP: '£',
    GBP: '£',
    GEL: '₾',
    GGP: '£',
    GHC: '₵',
    GHS: 'GH₵',
    GIP: '£',
    GMD: 'D',
    GNF: 'FG',
    GTQ: 'Q',
    GYD: 'G$',
    HKD: 'HK$',
    HNL: 'L',
    HRK: 'kn',
    HTG: 'G',
    HUF: 'Ft',
    IDR: 'Rp',
    ILS: '₪',
    IMP: '£',
    INR: '₹',
    IQD: 'ع.د',
    IRR: '﷼',
    ISK: 'kr',
    JEP: '£',
    JMD: 'J$',
    JOD: 'JD',
    JPY: '¥',
    KES: 'KSh',
    KGS: 'лв',
    KHR: '៛',
    KMF: 'CF',
    KPW: '₩',
    KRW: '₩',
    KWD: 'KD',
    KYD: '$',
    KZT: 'лв',
    LAK: '₭',
    LBP: '£',
    LKR: '₨',
    LRD: 'L$',
    LSL: 'M',
    LTC: 'Ł',
    LTL: 'Lt',
    LVL: 'Ls',
    LYD: 'LD',
    MAD: 'MAD',
    MDL: 'lei',
    MGA: 'Ar',
    MKD: 'ден',
    MMK: 'K',
    MNT: '₮',
    MOP: 'MOP$',
    MRO: 'UM',
    MRU: 'UM',
    MUR: '₨',
    MVR: 'Rf',
    MWK: 'MK',
    MXN: 'Mex$',
    MYR: 'RM',
    MZN: 'MT',
    NAD: '$',
    NGN: '₦',
    NIO: 'C$',
    NOK: 'kr',
    NPR: '₨',
    NZD: '$',
    OMR: '﷼',
    PAB: 'B/.',
    PEN: 'S/.',
    PGK: 'K',
    PHP: '₱',
    PKR: '₨',
    PLN: 'zł',
    PYG: 'Gs',
    QAR: '﷼',
    RMB: '￥',
    RON: 'lei',
    RSD: 'Дин.',
    RUB: '₽',
    RWF: 'R₣',
    SAR: '﷼',
    SBD: 'Si$',
    SCR: '₨',
    SDG: 'ج.س.',
    SEK: 'kr',
    SGD: '$',
    SHP: '£',
    SLL: 'Le',
    SOS: 'S',
    SRD: '$',
    SSP: '£',
    STD: 'Db',
    STN: 'Db',
    SVC: '₡',
    SYP: '£',
    SZL: 'E',
    THB: '฿',
    TJS: 'SM',
    TMT: 'T',
    TND: 'د.ت',
    TOP: 'T$',
    TRL: '₤',
    TRY: '₺',
    TTD: 'TT$',
    TVD: '$',
    TWD: 'NT$',
    TZS: 'TSh',
    UAH: '₴',
    UGX: 'USh',
    USD: '$',
    UYU: '$U',
    UZS: 'лв',
    VEF: 'Bs',
    VND: '₫',
    VUV: 'VT',
    WST: 'WS$',
    XAF: 'FCFA',
    XBT: 'Ƀ',
    XCD: '$',
    XOF: 'CFA',
    XPF: '₣',
    YER: '﷼',
    ZAR: 'R',
    ZWD: 'Z$'
};
